<template>
<div>
    <div class="row">
        <nav class="navbar navbar-default">
        <div class="container-fluid">
            <div class="navbar-form navbar-left">
                <div class="form-group">
                    <label for="squad_id" class="control-label">Squad:</label>
                    <select v-model="selected_squad" v-on:change='updateSelectedSquad' name='squad_id' id='squad_id' class='form-control chosen-select-disabled-to-enable-change-event'>
                        <option v-bind:value="squad" v-for="(squad, index) in squads">{{squad.name}}</option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="date" class="control-label">Date:</label>

                    <div class="input-group date datepicker">
                        <input type="text" name="date" id="date" class="form-control" />
                        <span class="input-group-addon" id="dob_addon">
                            <span class="glyphicon glyphicon-calendar"></span>
                        </span>
                    </div>
                </div>

                <button name="view-attendance" id="view-attendance" type="submit" value="view-attendance" class="btn btn-default" form='attendance-squad-form'>
                    View Attendance
                </button>
            </div>
                
            <div class="navbar-form navbar-right">
                    <button name='update-attendance' id='update-attendance' value="update-attendance" type="submit" class="btn btn-success">Save Attendance</button>
            </div>
        </div>
        </nav>
    </div>

    <div class="row">
        <table class="table table-condensed2 table-striped table-bordered">
            <tr>
                <th></th>
                <th  class="lead text-center">Monday</th>
                <th  class="lead text-center">Tuesday</th>
                <th  class="lead text-center">Wednesday</th>
                <th  class="lead text-center">Thursday</th>
                <th  class="lead text-center">Friday</th>
                <th  class="lead text-center">Saturday</th>
                <th  class="lead text-center">Sunday</th>
            </tr>

            <tr>
                <th></th>

            </tr>

        </table>
    </div>
</div>
</template>

<script>

    export default {

        // Props need to be defined so that we can pass them in from the HTML
        // but they aren't mutable so we need to have equivalent "date" variables
        // but they can't be the same name

        props: ['squad_id', 'attendance_date'],

        data: function () {
            return {
                squads: [],
                selected_squad: null,
                members: [
                    {
                        name: "Toby Redshaw",
                        asa_number: "903634",
                        id: 3,
                        sessions: [
                            {
                                id: 4,
                                percentage_attended: 50,
                                state: "Attended"
                            }
                        ]
                    }
                ],
                training_sessions: [
                    {
                        day_of_week: "Monday",
                        time: "18:15",
                        id: 5
                    }
                ]
            }
        },

        mounted() {
            console.log('START: mounted');
            this.refreshSquads();
            this.selected_squad = this.squads[0];
            console.log('75: ' + this.selected_squad);
            console.log('END: mounted');
        },
        methods: {
            refreshSquads() {
                axios.get('/api/squads').then((res) => {
                    console.log(res.data);
                    this.squads = res.data;
                    console.log(this.squads);
                });
            },
            updateSelectedSquad() {
                console.log('START: updateSelectedSquad');
                console.log(this.selected_squad);
                this.refreshSquadMembers();
                this.refreshSquadTrainingSchedule();
                console.log('END: updateSelectedSquad');
            },
            refreshSquadMembers() {
                axios.get('/api/squad/' + squad.id + '/members').then((res) => {
                    this.members = res.data;
                });
            },
            fetchMemberAttendance() {
                axios.get('/api/squads').then((res) => {
                    this.squads = res.data;
                });

            },
            refreshSquadTrainingSchedule() {
                axios.get('/api/squad' + squad.id + '/training_schedule').then((res) => {
                    this.training_sessions = res.data;
                });

            },
            fetchMemberAttendance() {
                axios.get('/api/tasks').then((res) => {
                    this.list = res.data;
                });

            },
            cycleOption() {
                // console.log('START cycleOption');
                // console.log(this.selected_index);
                // console.log(this.selected_option);
                this.selected_index++;
                if (this.selected_index > (this.attendance_options.length - 1)) {
                    this.selected_index = 0;
                }
                this.updateSelectedOption();
                // console.log(this.selected_index);
                // console.log(this.selected_option);
                // console.log(this.selected_option.label);
                // console.log(this.selected_option.style.background-color);
                // console.log('END cycleOption');
            },
            updateSelectedOption() {
                this.selected_option = this.attendance_options[this.selected_index];
            },
            // Updates the table colspan for training sessions, highlights the selected day and
            // makes columns visible/hidden based on screen size
            updateTableLayout() {
                
            }
        //             label.click(function () {
        //     var next = selectedOption().next();
        //     if (next.length === 0) {
        //         next = select.children('option:first');
        //     }
        //     next.prop('selected', 'true');
        //     label.prop('title', txt(next));
        // });
        }
    }
</script>
